import { openInIframe } from '@shared/iFrameHandler/openInIframe';
import { isTroubleshootFlow } from '@idConnect/identification/troubleshooting/handleTroubleshootService';
import { decodeBase64 } from '@shared/conversion/decodeBase64';
import { ConnectMessageType } from '@idConnect/types';
import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';
import { callEventListeners } from '@shared/events/callEventListeners';

export const setCookieDomain: Maker<Ctx, Snap, ConnectMessageType> = ({
  makeEffect,
}) => [
  makeEffect(
    'isTroubleshootFlow',
    (msg, { cond }) =>
      cond(isTroubleshootFlow(msg, 'setCookieDomain'), 'setCookieDomain'),
    (_, { ctx }) => {
      ctx.iframeMsgs?.shift();
      callEventListeners('onFlowCompleted', 'Utiq', {
        status: 'setCookieDomain',
      });
    },
  ),

  makeEffect(
    'valid',
    (msg, { pass, skip }) =>
      msg.SetCookieDomain && msg.SetCookieDomain !== ''
        ? pass(msg)
        : skip('SetCookieDomain', msg.SetCookieDomain),
    (msg, { ctx }) => {
      ctx.iframeMsgs?.shift()!;

      openInIframe({
        iFrameUrl: decodeBase64(msg.SetCookieDomain),
        iFrameId: 'SetCookieDomain',
        environment: 'Utiq',
      });
    },
  ),

  makeEffect(
    'invalid',
    (_, { pass }) => pass(null),
    (_, { ctx }) => ctx.iframeMsgs?.shift(),
  ),
];
